import { AnyEventObject } from 'xstate';
import { patchData, postData } from '~/utils/service';
import { Scope } from './../../../step-machine/types';
import { CompensationFormValues } from './types';
import { transformCompensationFormToApi } from './utils';

const ROUTE_NAME = 'msaasDetails';

export const API_CALLS = {
  create: async ({ input }: { input: Scope<CompensationFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await postData(ROUTE_NAME, {
      data: event.payload.values,
      transformRequest: transformCompensationFormToApi,
    });
  },
  patch: async ({ input }: { input: Scope<CompensationFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await patchData(ROUTE_NAME, {
      pathParams: { id: event.payload.values.id?.toString() || '' },
      data: event.payload.values,
      transformRequest: transformCompensationFormToApi,
    });
  },
};
